// extracted by mini-css-extract-plugin
export default {"firstSessionModal_container":"Jx","firstSessionModal_header":"Kx","firstSessionModal_title":"Lx","firstSessionModal_header_tex":"Mx","firstSessionModal_video":"Nx","firstSessionModal_videoContent":"Ox","firstSessionModal_FAQ":"Px","firstSessionModal_FAQMargin":"Qx","firstSessionModal_FAQTitle":"Rx","firstSessionModal_buttonContainer":"Sx","firstSessionModal_buttonText":"Tx","firstSessionModal_SMSBtn_mob":"Ux"};
    if(module.hot) {
      // 1737143654495
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  